import { RangePickerProps } from 'antd/es/date-picker';
import { ConfigType, Dayjs } from 'dayjs';
import dayjs from 'utils/moment/dayjsConfig';
import { ObjectType } from 'utils/types';

export const ISO8601_FORMAT = 'YYYY-MM-DD'; // định dạng payload, response API
export const DEFAULT_DATE_FORMAT = 'DD/MM/YYYY';
export const DEFAULT_DATE_TIME_FORMAT = 'DD/MM/YYYY, HH:mm';
export const DEFAULT_SHORT_DATE_FORMAT = 'D/M/YYYY';
export const DEFAULT_LONG_DATE_FORMAT = `ddd, ${DEFAULT_DATE_FORMAT}`;
export const DATE_FORMAT_PLACEHOLDER = '--/--/----';
export const DEFAULT_FULL_DATE_TIME_FORMAT = 'DD/MM/YYYY HH:mm:ss';
export const DEFAULT_TIME_FORMAT = 'HH:mm';

export const convertMillisecondsToDays = (milliseconds: number) =>
  milliseconds / (1000 * 60 * 60 * 24);

export const formatDisplayDate = (
  date: ConfigType,
  config?: {
    format?: string;
    timeZone?: string | null;
  }
) => {
  if (!date) return '-';

  const { format, timeZone } = config || {};

  return dayjs(date)
    .tz(timeZone || undefined)
    .format(format ?? 'MMM DD, YYYY');
};

export const formatDisplayTime = (
  dateTime: ConfigType,
  config?: {
    format?: string;
    timeZone?: string | null;
  }
) => {
  if (!dateTime) return '-';

  const { format, timeZone } = config || {};

  return dayjs(dateTime)
    .tz(timeZone || undefined)
    .format(format ?? 'h:mm A');
};

export const formatDisplayTimeAgo = (date: ConfigType, withSuffix?: boolean) =>
  date ? dayjs(date).fromNow(withSuffix) : '-';

export const getTimeDuration = (timeInMinute: number) => {
  const hours = Math.floor(timeInMinute / 60);
  const minutes = timeInMinute % 60;

  return `${hours}h${minutes}m`;
};

export const disabledPastDate: RangePickerProps['disabledDate'] = (
  day: Dayjs
) => day.isBefore(dayjs(), 'day');

export const disabledFutureDate: RangePickerProps['disabledDate'] = (
  day: Dayjs
) => day.isAfter(dayjs(), 'day');

/** Convert date in string DD/MM/YYYY to Dayjs object */
export const convertDateStringToObjectDate = (obj: ObjectType): ObjectType => {
  const result: ObjectType = {};
  const defaultDatePattern = /^\d{2}\/\d{2}\/\d{4}$/;

  for (const key in obj) {
    const value = obj[key];
    if (typeof value === 'string' && defaultDatePattern.test(value)) {
      result[key] = dayjs(value, 'DD/MM/YYYY');
    } else {
      result[key] = value;
    }
  }

  return result;
};

export const formatBeDateToAppDefaultDate = (value: any) => {
  if (!dayjs(value)?.isValid) return DATE_FORMAT_PLACEHOLDER;
  return dayjs(value, ISO8601_FORMAT).format(DEFAULT_DATE_FORMAT);
};
